import React from "react";

function SeveralDigitalMarketingIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="57"
            height="57"
            fill="none"
            viewBox="0 0 57 57"
        >
            <rect width="57" height="57" fill="#EF4F80" rx="10"></rect>
            <path
                fill="#fff"
                d="M36.868 20.136c-.846-2.802-1.953-4.191-3.313-4.134-.423.021-.818.189-1.176.499l-13.364 7.207-3.824.194c-1.488.075-2.716.945-3.46 2.451-1.093 2.218-.946 5.465.343 7.552.83 1.348 2.064 2.09 3.472 2.09.068 0 .137-.002.207-.005l.21-.011 1.061 4.158c.136.53.57.88 1.366 1.103.186.052.682.174 1.255.174.772 0 1.373-.217 1.784-.645.275-.285.695-.921.426-1.974l-.584-2.29 12.406 5.2a1.872 1.872 0 001.088.293c1.35-.069 2.33-1.566 2.914-4.45.48-2.367.66-5.475.508-8.752-.153-3.275-.621-6.35-1.319-8.66zm-1.665 8.409c-.056-1.198-.472-2.315-1.171-3.146-.504-.599-1.124-1.012-1.801-1.2.274-3.834 1.034-5.766 1.425-6.04.646.35 2.175 4.193 2.48 10.74.303 6.535-.872 10.588-1.46 10.948-.47-.222-1.518-2.52-2.111-6.646 1.634-.594 2.736-2.527 2.638-4.656zm9.583 5.41a.88.88 0 01-.051.65.811.811 0 01-.728.462.794.794 0 01-.373-.094l-2.809-1.508a.839.839 0 01-.404-.498.88.88 0 01.052-.65.803.803 0 011.1-.369l2.809 1.508a.843.843 0 01.404.498zm-3.952-8.274a.807.807 0 01-.688-.391.876.876 0 01.245-1.179l2.655-1.783a.799.799 0 011.13.255.877.877 0 01-.245 1.18l-2.655 1.783a.798.798 0 01-.442.135zm5.165 2.835c.022.47-.327.87-.777.893l-3.195.16c-.436 0-.795-.356-.816-.81a.87.87 0 01.212-.615.798.798 0 01.566-.279l3.154-.16a.836.836 0 01.856.81z"
            ></path>
        </svg>
    );
}

export default SeveralDigitalMarketingIcon;
